"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_router_dom_1 = require("react-router-dom");
var auth = __importStar(require("../helpers/auth"));
var Routes_1 = require("../constants/Routes");
var useIsHeaderActionsShow_1 = require("../hooks/useIsHeaderActionsShow");
var lodash_1 = require("lodash");
var AuthRoute = function (props) {
    var children = props.children, requireVerification = props.requireVerification, requireDeveloperSettingsValidation = props.requireDeveloperSettingsValidation, currentRoute = props.currentRoute, rest = __rest(props, ["children", "requireVerification", "requireDeveloperSettingsValidation", "currentRoute"]);
    currentRoute && useIsHeaderActionsShow_1.useIsHeaderActionsShow(currentRoute);
    var route = (react_1.default.createElement(react_router_dom_1.Route, __assign({}, rest, { render: function () {
            return children;
        } })));
    // We're on verification screen
    if (requireVerification === false) {
        return route;
    }
    if (requireVerification && auth.requiresVerification()) {
        return react_1.default.createElement(react_router_dom_1.Redirect, { to: Routes_1.Routes.Verify.path });
    }
    if (!lodash_1.isUndefined(requireDeveloperSettingsValidation) &&
        !requireDeveloperSettingsValidation) {
        return react_1.default.createElement(react_router_dom_1.Redirect, { to: '/account/settings' });
    }
    if (!auth.isAuthenticated()) {
        return react_1.default.createElement(react_router_dom_1.Redirect, { to: Routes_1.Routes.Home.path });
    }
    return route;
};
exports.default = AuthRoute;
